import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import {
  MdbCheckboxModule, MdbCollapseModule, MdbDropdownModule, MdbFormsModule, MdbPopoverModule,
} from 'mdb5-adapted';

import { LMSStyleConfigModule } from '../modules/style-config/style-config.module';
import { NavbarComponent } from './navbar.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MdbCollapseModule,
    MdbDropdownModule,
    MdbPopoverModule,
    MdbFormsModule,
    FormsModule,
    MdbCheckboxModule,
    LMSStyleConfigModule
],
  declarations: [
    NavbarComponent
  ],
  exports: [
    NavbarComponent
  ],
  providers: []
})
export class NavigationModule {

}
